
import {tap} from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

import {AfterViewChecked, AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';

import { RequeteCategory } from '../../../entities/requete';
import { SectionState } from '../../../shared/components/section/section.model';
import { saveOrOpenRawFile } from '../../../shared/core/util';
import { ErrorService } from '../../../shared/services/error.service';
import { DepotRequeteState } from '../../depot-requete-state.model';
import { DraftDepotRequeteService } from '../../draft-depot-requete.service';
import { ScrollToService } from '../../../shared';

const acteurSectionTitles = {
    [RequeteCategory.REQUERANT_SEUL]: 'Requérant principal (demandeur)',
    [RequeteCategory.COLLECTIVE]: 'Vous êtes le représentant unique des requérants',
    [RequeteCategory.AVEC_MANDATAIRE]: 'Vous êtes le mandataire'
};

@Component({
    selector: 'jhi-step-recapitulatif',
    templateUrl: './recapitulatif.component.html',
    styleUrls: ['recapitulatif.scss']
})
export class RecapitulatifComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
    depotRequeteState: DepotRequeteState;

    isDeactivatedPopup = false;
    isLoading = false;
    acteurSectionTitle: string;

    public reclamationPrealableIsComplementary: boolean;
    public reclamationPrealableIsMandatory: boolean;

    private draftRequeteSubscription: Subscription;
    private contentieuxSocialSubscription: Subscription;

    private scrollTarget: string;
    private scrollToError = false;
    public justificatifsAutoSaveSuccess = false;
    public saveDraftSuccess = false;
    public saveDraftError = false;
    private autoSaveTime: any;
    sections: { [key: string]: SectionState } = {
        acteur: { isToggleable: false },
        juridiction: { isToggleable: false },
        piecesObligatoires: { isToggleable: false },
        piecesComplementaires: { isToggleable: false },
        piecesPostales: { isToggleable: false },
        inventaire: { isToggleable: false }
    };

    // For validation only
    _recapitulatifEnregistrement = false;
    _recapitulatifRequeteAbusif = false;

    private inventaireBlob: Blob;

    @Output() previousStep: EventEmitter<any> = new EventEmitter();
    @Output() hideAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showErrorAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showSuccessAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showAutoSaveSuccessAlertDraft: EventEmitter<any> = new EventEmitter();

    @ViewChild(NgForm) form: NgForm;

    constructor(private errorService: ErrorService, private draftDepotRequeteService: DraftDepotRequeteService,
        private scrollToService: ScrollToService) {
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepJustificatifsAutoSaveSucceed) {
            this.justificatifsAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);

        }
        if (this.depotRequeteState.requeteCategory) {
            this.generateInventaire();
            this.acteurSectionTitle = acteurSectionTitles[this.depotRequeteState.requeteCategory];
        }
    }

    ngOnInit(): void {
        this.hideAlertDraft.emit();
        if (this.justificatifsAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    }

    ngAfterViewInit() {
        this.draftRequeteSubscription = this.draftDepotRequeteService.refreshRequete().subscribe(draftRequete => {
            console.log('ngAfterViewInit | draftRequete : ', draftRequete);
            this.depotRequeteState.concernContentieuxSocial =
            draftRequete.concernContentieuxSocial;
            if (draftRequete.contentieuxSocialId !== null) {
                this.contentieuxSocialSubscription =
                this.draftDepotRequeteService.getContentieuxSocial(draftRequete.contentieuxSocialId)
                .subscribe(cs => {
                    this.depotRequeteState.requeteCS = cs;
                    console.log('ngAfterViewInit | requeteCS : ', this.depotRequeteState.requeteCS);
                    if (this.depotRequeteState.requeteCS && this.depotRequeteState.requeteCS.souhait) {
                        if ((this.depotRequeteState.requeteCS.souhait ===
                            'Remplir le formulaire : litige lié à une somme d\'argent' &&
                        this.depotRequeteState.requeteCS.typeLitige ===
                        'Vous contestez une somme d\'argent réclamée par l\'administration') ||
                        this.depotRequeteState.requeteCS.souhait === 'Déposer une requête que vous avez rédigée') {
                            this.reclamationPrealableIsComplementary = true;
                            this.reclamationPrealableIsMandatory = false;
                        } else if (this.depotRequeteState.requeteCS.souhait ===
                            'Remplir le formulaire : litige lié à une somme d\'argent' &&
                        this.depotRequeteState.requeteCS.typeLitige !==
                        'Vous contestez une somme d\'argent réclamée par l\'administration') {
                            this.reclamationPrealableIsMandatory = true;
                            this.reclamationPrealableIsComplementary = false;
                        }
                    } else {
                        this.reclamationPrealableIsComplementary = false;
                        this.reclamationPrealableIsMandatory = false;
                    }
                })
            }
        });
      document.getElementById('logo-link').focus();
    }

    ngAfterViewChecked(): void {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    }

    ngOnDestroy(): void {
        this.draftRequeteSubscription.unsubscribe();
        if (this.contentieuxSocialSubscription) {
            this.contentieuxSocialSubscription.unsubscribe();
        }
    }

    save(): void {
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            this.isLoading = true;
            this.draftDepotRequeteService.depotRequete().subscribe(
                () => {
                    this.isLoading = false;
                },
                (error) => {
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                    this.isLoading = false;
                }
            );
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    }

    previous(): void {
        this.previousStep.emit();
    }

    saveDraft(): Observable<any> {
        this.hideAlertDraft.emit();

        return this.draftDepotRequeteService.updateStatusToRecapitulatif().pipe(tap(
            () => {
                this.saveDraftSuccess = true;
                this.justificatifsAutoSaveSuccess = false;
                this.showSuccessAlertDraft.emit();
            },
            (error) => {
                this.saveDraftError = true;
                this.justificatifsAutoSaveSuccess = false;
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        ));
    }

    generateInventaire() {
        this.draftDepotRequeteService.generateInventairePreview().subscribe(blob => {
            this.inventaireBlob = blob;
        });
    }

    openInventaire() {
        if (this.inventaireBlob) {
            this.draftDepotRequeteService.trackInventairePreviewDownload();
            try {
                saveOrOpenRawFile(this.inventaireBlob, 'Inventaire_des_pièces.pdf');
            } catch (e) {
                this.isDeactivatedPopup = true;
            }
        } else {
            this.draftDepotRequeteService.trackInventairePreviewFail();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/recapitulatif/recapitulatif.component.ts